module.exports = __webpack_public_path__ + "147c66fd4674706fc6a1def3a64fade7.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_large_x1/public/games/coh_image_1.jpg
// module id = 472
// module chunks = 0